(function () {
  function setPlaying(card, on) {
    var play = card.querySelector("[data-sale-videos-play]");
    card.classList.toggle("is-playing", on);
    if (on) card.classList.add("is-started");
    if (!play) return;
    play.classList.toggle("is-playing", on);
    play.setAttribute("aria-label", on ? "Pause video" : "Play video");
  }

  function pauseOthers(root, current) {
    root.querySelectorAll("[data-sale-videos-card]").forEach(function (card) {
      var video = card.querySelector("video");
      if (!video || video === current) return;
      video.pause();
      card.classList.remove("is-started");
      setPlaying(card, false);
    });
  }

  function initVideos(root) {
    root.querySelectorAll("[data-sale-videos-play]").forEach(function (play) {
      var card = play.closest("[data-sale-videos-card]");
      var video = card ? card.querySelector("video") : null;
      if (!card || !video || play.dataset.saleBound === "true") return;
      play.dataset.saleBound = "true";

      play.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (video.paused || video.ended) {
          if (video.ended) {
            try { video.currentTime = 0; } catch (err) {}
          }
          pauseOthers(root, video);
          var pending = video.play();
          setPlaying(card, true);
          if (pending && typeof pending.catch === "function") {
            pending.catch(function () {
              card.classList.remove("is-started");
              setPlaying(card, false);
            });
          }
          return;
        }
        video.pause();
        setPlaying(card, false);
      });

      video.addEventListener("click", function () {
        if (video.paused) return;
        video.pause();
        setPlaying(card, false);
      });

      video.addEventListener("ended", function () {
        card.classList.remove("is-started");
        setPlaying(card, false);
        try { video.currentTime = 0; } catch (err) {}
      });
    });
  }

  function init(root) {
    if (!root || root.dataset.saleVideosReady === "true" || typeof Swiper === "undefined") return;
    var swiperEl = root.querySelector("[data-sale-videos-swiper]");
    if (!swiperEl) return;
    root.dataset.saleVideosReady = "true";

    var count = swiperEl.querySelectorAll(".swiper-slide").length;
    var middle = count > 1 ? Math.floor((count - 1) / 2) : 0;
    var moved = false;
    var swiper = new Swiper(swiperEl, {
      slidesPerView: "auto",
      centeredSlides: true,
      centerInsufficientSlides: true,
      spaceBetween: 0,
      initialSlide: middle,
      slideToClickedSlide: true,
      navigation: {
        prevEl: root.querySelector("[data-sale-videos-prev]"),
        nextEl: root.querySelector("[data-sale-videos-next]"),
      },
      pagination: {
        el: root.querySelector("[data-sale-videos-dots]"),
        clickable: true,
      },
    });

    function centerStart() {
      if (moved) return;
      swiper.update();
      swiper.slideTo(middle, 0, false);
    }

    swiper.on("sliderFirstMove", function () {
      moved = true;
    });

    swiper.on("slideChange", function () {
      if (!moved && swiper.activeIndex === middle) return;
      moved = true;
      pauseOthers(root, null);
    });

    centerStart();
    requestAnimationFrame(centerStart);

    initVideos(root);
    root._saleVideosSwiper = swiper;
  }

  function initAll(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    context.querySelectorAll("[data-sale-videos]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    event.target.querySelectorAll("[data-sale-videos]").forEach(function (root) {
      if (root._saleVideosSwiper) root._saleVideosSwiper.destroy(true, true);
    });
  });
})();
